export class Location {
  id: number;
  name: string;
  enabled: boolean;

  // Por ahora guardamos siempre los levels
  //  @Exclude({ toPlainOnly: true })
  levels?: Location[];
}
